var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPhone = function SvgPhone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "phone_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1440 0v900H0V0h1440Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "phone_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.351 0c4.895.008 5.362.075 5.986.692l.078.078c.04.04.08.083.123.128l.462.487v25.23l-.462.487c-.056.06-.108.116-.16.168l-.075.076c-.6.581-1.152.646-5.93.653H6.627c-4.778-.007-5.33-.072-5.93-.653L.62 27.27l-.16-.168L0 26.615V1.385L.462.898c.261-.259.676-.563.923-.685C1.754.061 3.354.015 8.969 0ZM8.97 22.523c-.815 0-1.815 1.004-1.815 1.826 0 .822 1 1.826 1.815 1.826.877 0 1.877-.974 1.877-1.826 0-.533-.523-1.309-1.061-1.598-.262-.122-.616-.228-.816-.228ZM15.615 2.13H2.385v18.261h13.23V2.131Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#phone_svg__a)",
    transform: "translate(-456 -409)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#phone_svg__b)",
    transform: "translate(463 411)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#7E53F0",
    opacity: "90%",
    d: "M0 0h18v28H0V0z"
  })))));
};
export default SvgPhone;